import React, { useRef, useState, ChangeEvent } from "react";
import { useCardcaseModel } from "../cardcaseModel";
import { YHDrawer } from "@/components/YhDrawer";
import { Button, Input, message, Table } from "antd";
import { YhBut } from "@/components/YhButton";
import { getRandomStr } from "@/utils/utils";
import { ColumnsType } from "antd/lib/table";
import { EditableCell, EditableRow } from "@/components/YHEditTable/editTable";

interface IGroupHandle {
    visible: boolean,
    mode: "add" | "edit",
    val?: string,
}

export function GroupDrawer() {
    const [operate, setOperate] = useState<IGroupHandle>({ visible: false, mode: "add" });
    const [selectIndex, setSelectIndex] = useState<number>(-1);  //选中的分组
    const { groupVisible: visible, setGroupVisible, dataGroupSource, editCardGroup, setDataGroupSource, insertCardGroup } = useCardcaseModel();
    const [loading, setLoading] = useState<boolean>(false);
    const onCancel = () => {
        setGroupVisible(false);
        setOperate({ visible: false, mode: "add" })
        setSelectIndex(-1)
    }

    //分组名称修改
    const onValChange = (e: ChangeEvent<HTMLInputElement>) => {
        setOperate(origin => ({ ...origin, val: e.target.value }))
    }
    //提交
    const onSubmit = async () => {
        if (!operate.val) {
            message.warning("请输入分组名称");
            return;
        }
        if (operate.mode === "add") {
            let res = await insertCardGroup({
                code: getRandomStr(),
                name: operate.val
            })
            res && setOperate({ visible: false, mode: "add" })
            setSelectIndex(-1)
        } else if (operate.mode === "edit") {
            let res = await editCardGroup({
                ...dataGroupSource[selectIndex],
                name: operate.val
            })
            res && setOperate({ visible: false, mode: "add" })
            setSelectIndex(-1)
        }
    }


    const columns = [
        {
            title: '序号',
            width: 60,
            fixed: "left",
            align: 'center',
            render: (t: any, r: any, i: number) => <>{i + 1}</>
        }, {
            title: '分组名称',
            width: 200,
            fixed: "left",
            dataIndex: 'name',
            editable: true,
        }, {
            title: '备注',
            dataIndex: 'note',
            editable: true,
        }
    ];

    const newSelectColumns = () =>
        columns.map((col: any, index) => {
            return {
                ...col,
                onCell: (record: any, rowIndex: number) => ({
                    colIndex: index,
                    rowIndex,
                    record,
                    rules: col?.rules,
                    options: col?.options,
                    editType: col?.editType,
                    editable: col?.editable,
                    onSelectChange: col?.onSelectChange,
                    onSelectFocus: col?.onSelectFocus,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: handleSave,
                }),
            }
        })

    const handleSave = async (row: any) => {
        let newData = [...dataGroupSource];
        const index = newData.findIndex((item) => row.id === item.id);
        const item = newData[index];
        if (row.name !== newData[index].name || row.note !== newData[index].note) {
            setLoading(true)
            let res = await editCardGroup(row);
            setLoading(false)
        }
        // newData.splice(index, 1, { ...item, ...row });
        // setDataGroupSource([...newData]);
    }

    return (
        <YHDrawer
            {...{
                title: "分组配置",
                visible,
                onCancel,
                okText: "确定",
                onOk: onCancel,
                width: 900
            }}
        >
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => setOperate({ visible: true, mode: "add" })}
            >添加分组</Button>
            {/* <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => {
                    if (selectIndex < 0) {
                        message.warning("请选择你要重命名的数据");
                        return;
                    }
                    setOperate({ visible: true, mode: "edit", val: dataGroupSource[selectIndex].name })
                }}
            >重命名</Button> */}

            {operate.visible && <div className="add-group">
                <Input
                    size="small"
                    placeholder='请输入分组名称'
                    value={operate.val}
                    onChange={onValChange}
                />
                <YhBut
                    type="add"
                    txt="确定"
                    click={() => onSubmit()}
                />
            </div>}

            <Table
                loading={loading}
                style={{ marginTop: '10px' }}
                rowClassName='editable-row yh-edit-table-tr'
                rowKey={record => record.id as string}
                columns={newSelectColumns() as ColumnsType<any>}
                dataSource={dataGroupSource}
                pagination={false}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    }
                }}
                scroll={{ x: 'max-content', y: "calc(100vh - 334px)"  }}
            />
            {/* <div className="group-wrap">
                {dataGroupSource && dataGroupSource.map((item, index) => <div className={selectIndex === index ? "groupSelect" : ""} onClick={() => setSelectIndex(index)} key={item.id}>{item.name}</div>)}
            </div> */}
        </YHDrawer>
    )
}
